import React from "react";
import { PaymentProvider } from "./context";
import CartPage from "./pages/front/CartPage";
import CheckoutPage from "./pages/front/CheckoutPage";
import AdditionalServicesPage from "./pages/front/AdditionalServicesPage";
import AuthRoute from "../auth/components/routes/AuthRoute";
import { Route, Switch } from "react-router";
import { UserRole } from "../user/enums/UserRole";
import CommonRoute from "../auth/components/routes/CommonRoute";
import { Routes } from "../../constants/routes";
import MakeCustomPaymentPage from "./pages/front/MakeCustomPaymentPage";
import SubscriptionPaymentPage from "./pages/front/SubscriptionPaymentPage";
import MakeServicePaymentPage from "./pages/front/MakeServicePaymentPage";

export default function Payment({ path }: { path: string }) {
  return (
    <Route path={path}>
      <PaymentProvider>
        <Switch>
          <AuthRoute
            showCart
            exact
            roles={[UserRole.Student, UserRole.Parent]}
            component={AdditionalServicesPage}
            path={`${path}extra-services`}
          />
          <AuthRoute
            showCart
            exact
            roles={[UserRole.Student, UserRole.Parent]}
            component={CartPage}
            path={`${path}cart`}
          />
          <AuthRoute
            exact
            roles={[UserRole.Student, UserRole.Parent]}
            component={CheckoutPage}
            path={`${path}checkout`}
          />
          <CommonRoute
            exact
            component={MakeCustomPaymentPage}
            path={`${path}${Routes.MAKE_PAYMENT}`}
          />
          <CommonRoute
            exact
            component={MakeServicePaymentPage}
            path={`${path}${Routes.MAKE_SERVICE_PAYMENT}`}
          />
          <CommonRoute
            exact
            component={SubscriptionPaymentPage}
            path={`${path}${Routes.SUBSCRIBE}`}
          />
        </Switch>
      </PaymentProvider>
    </Route>
  );
}
